import './JewelleryOptionsDesign.svelte.css';
/* src/components/JewelleryOptions/JewelleryOptionsDesign.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	src_url_equal,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[17] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[17] = list[i];
	return child_ctx;
}

// (61:4) {#if hasItem(item.accessoryType_id, countItems)}
function create_if_block_3(ctx) {
	let li;
	let input;
	let input_id_value;
	let input_value_value;
	let input_class_value;
	let t0;
	let label;
	let t1_value = /*item*/ ctx[17].name + "";
	let t1;
	let label_for_value;
	let label_class_value;
	let t2;
	let mounted;
	let dispose;

	function change_handler() {
		return /*change_handler*/ ctx[13](/*item*/ ctx[17]);
	}

	return {
		c() {
			li = element("li");
			input = element("input");
			t0 = space();
			label = element("label");
			t1 = text(t1_value);
			t2 = space();
			attr(input, "name", "lit_bto_accode[2]");
			attr(input, "type", "radio");
			attr(input, "id", input_id_value = "atid_" + /*item*/ ctx[17].accessoryType_id);
			input.__value = input_value_value = /*item*/ ctx[17].accessoryType_id;
			input.value = input.__value;
			attr(input, "class", input_class_value = "t_code" + /*item*/ ctx[17].accessoryType_id + " svelte-1frdvmr");
			/*$$binding_groups*/ ctx[12][0].push(input);
			attr(label, "for", label_for_value = "atid_" + /*item*/ ctx[17].accessoryType_id);
			attr(label, "class", label_class_value = "t_code" + /*item*/ ctx[17].accessoryType_id + " svelte-1frdvmr");
			attr(li, "class", "svelte-1frdvmr");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, input);
			input.checked = input.__value === /*groupType*/ ctx[4];
			append(li, t0);
			append(li, label);
			append(label, t1);
			append(li, t2);

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_handler*/ ctx[11]),
					listen(input, "change", change_handler)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*jewelleryType*/ 2 && input_id_value !== (input_id_value = "atid_" + /*item*/ ctx[17].accessoryType_id)) {
				attr(input, "id", input_id_value);
			}

			if (dirty & /*jewelleryType*/ 2 && input_value_value !== (input_value_value = /*item*/ ctx[17].accessoryType_id)) {
				input.__value = input_value_value;
				input.value = input.__value;
			}

			if (dirty & /*jewelleryType*/ 2 && input_class_value !== (input_class_value = "t_code" + /*item*/ ctx[17].accessoryType_id + " svelte-1frdvmr")) {
				attr(input, "class", input_class_value);
			}

			if (dirty & /*groupType*/ 16) {
				input.checked = input.__value === /*groupType*/ ctx[4];
			}

			if (dirty & /*jewelleryType*/ 2 && t1_value !== (t1_value = /*item*/ ctx[17].name + "")) set_data(t1, t1_value);

			if (dirty & /*jewelleryType*/ 2 && label_for_value !== (label_for_value = "atid_" + /*item*/ ctx[17].accessoryType_id)) {
				attr(label, "for", label_for_value);
			}

			if (dirty & /*jewelleryType*/ 2 && label_class_value !== (label_class_value = "t_code" + /*item*/ ctx[17].accessoryType_id + " svelte-1frdvmr")) {
				attr(label, "class", label_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			/*$$binding_groups*/ ctx[12][0].splice(/*$$binding_groups*/ ctx[12][0].indexOf(input), 1);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (60:3) {#each jewelleryType as item}
function create_each_block_1(ctx) {
	let show_if = /*hasItem*/ ctx[10](/*item*/ ctx[17].accessoryType_id, /*countItems*/ ctx[6]);
	let if_block_anchor;
	let if_block = show_if && create_if_block_3(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*jewelleryType, countItems*/ 66) show_if = /*hasItem*/ ctx[10](/*item*/ ctx[17].accessoryType_id, /*countItems*/ ctx[6]);

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (86:3) {#if selectedTypeID === item.typeID}
function create_if_block_2(ctx) {
	let li;
	let input;
	let input_value_value;
	let input_id_value;
	let t0;
	let label0;
	let t1;
	let label0_for_value;
	let t2;
	let label1;
	let t3_value = /*item*/ ctx[17].designName + "";
	let t3;
	let label1_for_value;
	let t4;
	let li_class_value;
	let mounted;
	let dispose;

	function change_handler_1() {
		return /*change_handler_1*/ ctx[15](/*item*/ ctx[17]);
	}

	return {
		c() {
			li = element("li");
			input = element("input");
			t0 = space();
			label0 = element("label");
			t1 = text(" ");
			t2 = space();
			label1 = element("label");
			t3 = text(t3_value);
			t4 = space();
			attr(input, "type", "radio");
			attr(input, "name", "lit_bto_accode[0]");
			input.__value = input_value_value = /*item*/ ctx[17].id;
			input.value = input.__value;
			attr(input, "id", input_id_value = "input_" + /*item*/ ctx[17].code + "_" + /*item*/ ctx[17].typeID);
			attr(input, "class", "svelte-1frdvmr");
			/*$$binding_groups*/ ctx[12][1].push(input);
			attr(label0, "class", "start_bto_labelbutton svelte-1frdvmr");
			set_style(label0, "background-image", "url(" + /*item*/ ctx[17].srcS + ")");
			attr(label0, "for", label0_for_value = "input_" + /*item*/ ctx[17].code + "_" + /*item*/ ctx[17].typeID);
			attr(label1, "class", "start_bto_caption svelte-1frdvmr");
			attr(label1, "for", label1_for_value = "input_" + /*item*/ ctx[17].code + "_" + /*item*/ ctx[17].typeID);
			attr(li, "class", li_class_value = "t_code" + /*item*/ ctx[17].typeID + " " + /*isSelectedDesign*/ ctx[9](/*item*/ ctx[17].id, /*selectedTypeID*/ ctx[3] ?? '') + " svelte-1frdvmr");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, input);
			input.checked = input.__value === /*groupDesign*/ ctx[5];
			append(li, t0);
			append(li, label0);
			append(label0, t1);
			append(li, t2);
			append(li, label1);
			append(label1, t3);
			append(li, t4);

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_handler_1*/ ctx[14]),
					listen(input, "change", change_handler_1)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*groupDesign*/ 32) {
				input.checked = input.__value === /*groupDesign*/ ctx[5];
			}

			if (dirty & /*selectedTypeID*/ 8 && li_class_value !== (li_class_value = "t_code" + /*item*/ ctx[17].typeID + " " + /*isSelectedDesign*/ ctx[9](/*item*/ ctx[17].id, /*selectedTypeID*/ ctx[3] ?? '') + " svelte-1frdvmr")) {
				attr(li, "class", li_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			/*$$binding_groups*/ ctx[12][1].splice(/*$$binding_groups*/ ctx[12][1].indexOf(input), 1);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (85:2) {#each designList as item}
function create_each_block(ctx) {
	let if_block_anchor;
	let if_block = /*selectedTypeID*/ ctx[3] === /*item*/ ctx[17].typeID && create_if_block_2(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (/*selectedTypeID*/ ctx[3] === /*item*/ ctx[17].typeID) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (116:1) {#if 'typeID' in selectedDesign}
function create_if_block_1(ctx) {
	let div;
	let img;
	let img_class_value;
	let img_src_value;

	return {
		c() {
			div = element("div");
			img = element("img");
			attr(img, "class", img_class_value = "t_code" + /*selectedDesign*/ ctx[2].typeID + " svelte-1frdvmr");
			if (!src_url_equal(img.src, img_src_value = /*selectedDesign*/ ctx[2].src.replace('/m_img', '/l_img'))) attr(img, "src", img_src_value);
			attr(img, "alt", "デザインイメージ");
			attr(div, "class", "design-view svelte-1frdvmr");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, img);
		},
		p(ctx, dirty) {
			if (dirty & /*selectedDesign*/ 4 && img_class_value !== (img_class_value = "t_code" + /*selectedDesign*/ ctx[2].typeID + " svelte-1frdvmr")) {
				attr(img, "class", img_class_value);
			}

			if (dirty & /*selectedDesign*/ 4 && !src_url_equal(img.src, img_src_value = /*selectedDesign*/ ctx[2].src.replace('/m_img', '/l_img'))) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (131:1) {:else}
function create_else_block(ctx) {
	let t;

	return {
		c() {
			t = text("デザインを選択してください。");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (127:1) {#if 'typeID' in selectedDesign}
function create_if_block(ctx) {
	let a;
	let t;

	return {
		c() {
			a = element("a");
			t = text("このデザインをもとに作成する");
			attr(a, "class", "lit-gradient-button");
			attr(a, "href", /*ordermadeURL*/ ctx[7]);
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, t);
		},
		p(ctx, dirty) {
			if (dirty & /*ordermadeURL*/ 128) {
				attr(a, "href", /*ordermadeURL*/ ctx[7]);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let strong0;
	let t1;
	let ul0;
	let t2;
	let strong1;
	let t4;
	let ul1;
	let t5;
	let br;
	let t6;
	let div1_class_value;
	let t7;
	let div2;
	let each_value_1 = /*jewelleryType*/ ctx[1];
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = /*designList*/ ctx[8];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block0 = 'typeID' in /*selectedDesign*/ ctx[2] && create_if_block_1(ctx);

	function select_block_type(ctx, dirty) {
		if ('typeID' in /*selectedDesign*/ ctx[2]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block1 = current_block_type(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			strong0 = element("strong");
			strong0.textContent = "アクセサリタイプを選択";
			t1 = space();
			ul0 = element("ul");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t2 = space();
			strong1 = element("strong");
			strong1.textContent = "デザインを選択";
			t4 = space();
			ul1 = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t5 = space();
			br = element("br");
			t6 = space();
			if (if_block0) if_block0.c();
			t7 = space();
			div2 = element("div");
			if_block1.c();
			attr(ul0, "class", "jewellery-type-list svelte-1frdvmr");
			attr(div0, "id", "start_bto_type");
			attr(div0, "style", "");
			attr(ul1, "class", "jewellery-design-list svelte-1frdvmr");
			attr(div1, "id", "start_bto_design");
			attr(div1, "class", div1_class_value = "t_code" + /*design*/ ctx[0].typeCode + " svelte-1frdvmr");
			attr(div2, "class", "start-ordermade svelte-1frdvmr");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, strong0);
			append(div0, t1);
			append(div0, ul0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(ul0, null);
			}

			append(div1, t2);
			append(div1, strong1);
			append(div1, t4);
			append(div1, ul1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul1, null);
			}

			append(div1, t5);
			append(div1, br);
			append(div1, t6);
			if (if_block0) if_block0.m(div1, null);
			insert(target, t7, anchor);
			insert(target, div2, anchor);
			if_block1.m(div2, null);
		},
		p(ctx, [dirty]) {
			if (dirty & /*jewelleryType, groupType, selectedTypeID, hasItem, countItems*/ 1114) {
				each_value_1 = /*jewelleryType*/ ctx[1];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(ul0, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty & /*designList, isSelectedDesign, selectedTypeID, groupDesign, selectedDesign*/ 812) {
				each_value = /*designList*/ ctx[8];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul1, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if ('typeID' in /*selectedDesign*/ ctx[2]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(div1, null);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*design*/ 1 && div1_class_value !== (div1_class_value = "t_code" + /*design*/ ctx[0].typeCode + " svelte-1frdvmr")) {
				attr(div1, "class", div1_class_value);
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block1) {
				if_block1.p(ctx, dirty);
			} else {
				if_block1.d(1);
				if_block1 = current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(div2, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if (detaching) detach(t7);
			if (detaching) detach(div2);
			if_block1.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let ordermadeURL;
	let { design } = $$props;
	let { jewelleryType } = $$props;
	let designList = design.list;
	let selectedDesign = {};
	let selectedTypeID = '1';
	let groupType;
	let groupDesign;
	let countItems = [];

	const isSelectedDesign = (id, selected) => {
		return selected === id ? 'selectedDesign' : '';
	};

	const hasItem = (typeID, countList) => {
		return countList[typeID] ?? false;
	};

	const makeURL = (design, item) => {
		let label = '';

		if (design.label) {
			label = '&lc=' + design.label;
		}

		return design.action + '?code=' + item.code + '_' + design.arrangement + '_' + item.typeID + label;
	};

	onMount(() => {
		$$invalidate(4, groupType = design.typeID ?? '');
		$$invalidate(5, groupDesign = design.id ?? '');
		$$invalidate(3, selectedTypeID = design.typeID ?? '1');

		design.list.forEach(item => {
			$$invalidate(6, countItems[item.typeID] = true, countItems);

			if (design.id === item.id) {
				$$invalidate(2, selectedDesign = item);
			}
		});
	});

	const $$binding_groups = [[], []];

	function input_change_handler() {
		groupType = this.__value;
		$$invalidate(4, groupType);
	}

	const change_handler = item => {
		$$invalidate(3, selectedTypeID = item.accessoryType_id);
	};

	function input_change_handler_1() {
		groupDesign = this.__value;
		$$invalidate(5, groupDesign);
	}

	const change_handler_1 = item => {
		$$invalidate(2, selectedDesign = item);
	};

	$$self.$$set = $$props => {
		if ('design' in $$props) $$invalidate(0, design = $$props.design);
		if ('jewelleryType' in $$props) $$invalidate(1, jewelleryType = $$props.jewelleryType);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*design, selectedDesign*/ 5) {
			$: $$invalidate(7, ordermadeURL = makeURL(design, selectedDesign));
		}
	};

	return [
		design,
		jewelleryType,
		selectedDesign,
		selectedTypeID,
		groupType,
		groupDesign,
		countItems,
		ordermadeURL,
		designList,
		isSelectedDesign,
		hasItem,
		input_change_handler,
		$$binding_groups,
		change_handler,
		input_change_handler_1,
		change_handler_1
	];
}

class JewelleryOptionsDesign extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { design: 0, jewelleryType: 1 });
	}
}

export default JewelleryOptionsDesign;